<template>
    <span :class="klass">{{text}}</span>
</template>

<script>

const colors = {
    IN_PREPARATION: "warning",
    IN_TRAVEL: "warning",
    DELIVERED: "success",
    PICKUP: "success",
    CANCEL_BY_BUYER: "danger",
    CANCEL_BY_SELLER: "danger"
}

const text = {
    IN_PREPARATION: "Pendiente",
    IN_TRAVEL: "Pendiente",
    DELIVERED: "Confirmada",
    PICKUP: "Confirmada",
    CANCEL_BY_BUYER: "Cancelada",
    CANCEL_BY_SELLER: "Cancelada"
}

export default {
    name: "BadgeStateBuy",
    props:{
        state: {
            type: String,
            defualt: "IN_PREPARATION"
        }
    },
    computed: {
        klass: function(){
            return "badge mr-1 badge-"+colors[this.state];
        },
        text: function(){
            return text[this.state]
        }
    }
}
</script>